import script from "./ChatMessageContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMessageContent.vue?vue&type=script&setup=true&lang=ts"

import "./ChatMessageContent.vue?vue&type=style&index=0&id=9cbce20e&lang=scss"

const __exports__ = script;

export default __exports__